export const whoisLukas = `

#### How would you describe yourself?
Hi, I'm Lukas (born 1983, T1D from 2003) from Czech Republic. Although I have background in philosophy and drums, I am active in T1D community for more than 7 years. When I met the T1D for the first time, on my 20th birthday exactly, I refused to accept it. Many years of fighting and pushing back and forth followed, from which I usually walked away as a loser, unexpectedly. The results were dismal. In 2017, I met AAPS and the community around it and my life literally changed (THANK YOU, community). I quickly have turned T1D into a hobby, a partner who I (have to) live in the same household with, and I want to have the best relationship with her (T1D is a feminine noun in Czech). And only then did things start to work incredibly well for us. Very soon I started to pay it back to community, helping with translations, educations, presentations and tech talks (PaciMed, Diaktiv, Dialidi, Diakobraz, Diastyl, etc.).
<br />
<br />

#### Can you tell us something special about you that not so many people know?
Many people do not know even Lukáš Trčka have TIR below 100% sometimes 😉
<br />
<br />

#### What were the biggest challenges you faced with your DIY closed-loop journey?
The biggest challenge was to get started. To overcome the fear of IT-related content – as every DIY looper becomes IT specialist at some time. I have read the whole wiki before the first repo clone. For half a year I used AAPS in open loop mode and with virtual pump, with glucometer permanently connected with cable to the phone (NS uploader) and made all changes manually on an unsupported pump – but the results were breath-taking.
<br />
Over time, I figured out how things and my diabetes work and the results improved quickly. I was also lucky to have an endo who does not worry about the equipment and technology used, she is very supportive, open-minded and focused on my results. I soon became an exemplary patient educating other endos and their patients in the region about AAPS. In parallel with that I voluntarily started to be a beta user or experimenter trying all different pumps, apps and CGMs.
<br />
I started with AMA algo back in 2017, soon switched to SMB, followed by DynISF (that entirely replaced all my automations). In the meantime, I tested several experimental UAM branches (AIMI, Tsunami, Boost, AutoISF, EatingNow) and for quite some time now I use AutoISF with Activity monitor in FCL-ish mode (no carb entry, no counting, minimum manual bolusing).
<br />
<br />

#### Can you tell us about your diabetes journey and what led you to open-source looping?
I was driven to DIY by frustration with existing commercial solutions that didn't provide the best possible compensation, or didn't allow to connect CGM to the watch or bike computer.
<br />
In Czech Republic we didn't have any reimbursed pumps that communicated with Loop before, so as an Android user I logically ended up with AAPS. Luckily the father of AAPS himself is from the same country and we first met in 2017 at a weekend AAPS workshop, which gave me more knowledge and useful information than years on the internet. From that moment I am in contact with the community and the devs on a daily basis. I also help with educational weekend workshops coordination.
<br />
<br />

#### What are the biggest benefits you've experienced with open-source looping?
Better sleep (the very first thing you noticed after the switch – how bad your sleep was before and you did not realize).
<br />
Ability to use different CGMs and pumps without losing features or the entire ecosystem.
<br />
Life and results of non-diabetic person.
<br />
The mind switch: I am not passive victim of T1D, but active partner, co-creator and her parent/tamer at the same time.
<br />
<br />

#### Have you faced any major issues with your open source loop setup? How did you solve them?
I would not say major, but over the time (and with HW/SW changes and failures) there were plenty of minor ones that non-experienced user or parent sees as giant. But the good news is you as a T1D person have indefinite number of attempts to solve it and do it better next day. Most of them have simple solutions – get more information and ask more experienced fellow loopers who are patient enough.
<br />
<br />

#### What's your advice for beginners and those struggling with control?
The loop itself is not a magic wand or solution of all your struggles. The most important thing is our attitude and mindset:
<br />
Know YOUR diabetes.
<br />
Knowledge is power. Educate yourself.
<br />
Avoid manual corrections, do not be overmotivated.
<br />
Turn one button at a time and do not use buttons you are not familiar with.
<br />
Search for patterns, learn from your mistakes and do not repeat them.
<br />
Re-evaluate and re-check your settings regularly.
<br />
Watch your IOB closely (before meals, before activities, after wake-up).
<br />
Have a backup solution ready, always.
<br />
Resist the urge to make changes based on single event.
<br />
Do not bolus over your carb threshold.
<br />
When switching from pens or „dumb“ pumps, rethink your DIA and try to not overcompensate lows.
<br />
Quality of life is just as important as good glucose control.
<br />
<br />

#### Where do you see yourself in 10 years?
Ten years from now, I'd like to be at least as happy as I am today. I'd be grateful for more reliable CGMs and even faster insulins.
<br />
<br />

<!-- blog-contact-footer -->
`;
